import type { PageConfig } from '../../common';
import type { ALPChartView, ALPTableView, DefaultPathType, FilterBar, Header, Table } from '../controls';

export enum VariantManagementTypeListReport {
    None = 'None',
    Control = 'Control',
    Page = 'Page'
}

//Class implementations of the interfaces with sync rules at packages/specification/src/sync/v4/export/pages/ListReport.ts

export interface ListReportConfigV4 extends PageConfig {
    /**
     * variantManagement defines how the variant management of page personalizations is controlled.
     * - None - No variant management by default.
     * - Control - Individual personalizations for each control.
     */
    variantManagement?: VariantManagementTypeListReport;
    /**
     * Header
     */
    header?: Header;
    /**
     * Filter Bar
     */
    filterBar?: FilterBar;

    /**
     * Chart
     */
    chart?: ALPChartView;

    /**
     * Table
     */
    table?: Table | ALPTableView;

    /**
     * defaultTemplateAnnotationPath must be a reference to a SelectionPresentationVariant.
     * You use the SelectionPresentationVariant to configure the default visualizations and default filter values of the main content area.
     */
    defaultTemplateAnnotationPath?: string;

    /**
     * Defines the initial view mode:
     * - primary: This property loads the app in chart-only view.
     * - secondary: This property loads the app in table-only view.
     * - both: This property loads the app in hybrid view.
     */
    defaultPath?: DefaultPathType;
}
